"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var token_1 = require("../models/token");
var KEY_TOKEN = 'pacifico-tools-system-token';
var AuthToken = /** @class */ (function () {
    function AuthToken() {
    }
    AuthToken.config = function (storage) {
        AuthToken.store = storage;
    };
    AuthToken.getToken = function () {
        var tokenString = AuthToken.store.getItem(KEY_TOKEN) || null;
        var token = new token_1.Token();
        token = JSON.parse(tokenString);
        return token;
    };
    AuthToken.setToken = function (token) {
        if (token) {
            AuthToken.store.setItem(KEY_TOKEN, JSON.stringify(token));
        }
        else {
            AuthToken.store.removeItem(KEY_TOKEN);
        }
    };
    AuthToken.getAuthorization = function () {
        var token = AuthToken.getToken();
        return token.tokenType + " " + token.accessToken;
    };
    return AuthToken;
}());
exports.default = AuthToken;
